import React, { useState } from "react";
import { CLIENT } from "../../Router/paths";
import { useNavigate } from "react-router-dom";
// import { FaTimes } from "react-icons/fa";
import { useLoader, useModal } from "../../context/LoaderContext";
import { axiosInstance } from "../../config/https";
import { toast } from "react-toastify";
import CreatableSelect from "react-select/creatable";
import { skills } from "../../utils";

export default function JobDetailsComp() {
  const navigate = useNavigate();
  const { startLoader, stopLoader } = useLoader();
  const { openModal } = useModal();
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [jobSkills, setJobSkills] = useState([]);
  const [scope, setScope] = useState("");
  const [term, setTerm] = useState("");
  const [experinceNeeded, setExperinceNeeded] = useState("");
  const [length, setLength] = useState("");
  const [budget, setBudget] = useState(0);

  const handleInputChange = (e, func) => {
    func(e.target.value);
  };
  const JS = jobSkills.map((e) => {
    return {
      name: e.value,
    };
  });

  const postJob = (e) => {
    e.preventDefault();
    const rowData = {
      term: term,
      job_title: title,
      skills: JS,
      scope: scope,
      length: length,
      experience_needed: experinceNeeded,
      hire_opp: true,
      project_budget: budget, // Correct decimal format
      description: description,
    };

    startLoader();
    axiosInstance
      .post("/api/jobposts/", rowData)
      .then((resp) => {
        stopLoader();
        const Data = resp.data;
        if (resp.status === 200 || resp.status === 201) {
          openModal(
            "jobPosted", //gif url
            "Congratulations!", //title
            "Your job has been successfully posted. Talented freelancers are ready to bid and bring your project to life." //subtitle
          );
          // toast.success(Data.message);
          navigate(CLIENT.jobPost);
        } else {
          toast.warning(Data.msg);
        }
      })
      .catch(() => {
        stopLoader();
      });
  };

  const onChange = (e) => {
    setJobSkills(e);
  };
  return (
    <section className="job-detail pc-p-3">
      <div className="container">
        <div className="job-detail-box primary-heading color-dark">
          <h4 className="primary-color mb-3">Job Details</h4>
          <form className="job-form" onSubmit={postJob}>
            <div className="row">
              <div className="col-lg-12 col-md-12 col-12">
                <div className="form-group">
                  <h6 className="mb-2">Project Title</h6>
                  <input
                    type="text"
                    placeholder="Enter Project Title"
                    className="form-control px-3"
                    onChange={(e) => handleInputChange(e, setTitle)}
                  />
                </div>
                <div className="form-group">
                  <h6 className="mb-2">Description</h6>
                  <textarea
                    className="form-control"
                    rows={10}
                    placeholder="Already have a description? Paste it here"
                    onChange={(e) => handleInputChange(e, setDescription)}
                  />
                </div>
              </div>
              {/* <div className="col-lg-12 col-md-6 col-12">
                <div className="form-group">
                          <h6 className="mb-2">Category</h6>
                          <select className="form-control">
                              <option value="">Graphic Desigining</option>
                          </select>
                      </div>
              </div> */}
              <div className="col-lg-12 col-md-6 col-12">
                <div className="form-group">
                  <h6 className="mb-2">Job Skills</h6>
                  <CreatableSelect
                    isMulti
                    options={skills}
                    onChange={onChange}
                  />
                  {/* <ul className="select-tag">
                    <li className="mr-3">
                      Graphics Design <FaTimes />
                    </li>
                    <li>
                      Social Media <FaTimes />
                    </li>
                  </ul> */}
                </div>
              </div>
              <div className="col-lg-12 col-md-6 col-12">
                <div className="form-group w-100">
                  <h6 className="mb-2">Scope</h6>
                  <select
                    className="form-control w-100"
                    onChange={(e) => handleInputChange(e, setScope)}
                  >
                    <option value="select">Select</option>
                    <option value="large">Large</option>
                    <option value="medium">Medium</option>
                    <option value="small">Small</option>
                  </select>
                </div>
                <div className="form-group">
                  <h6 className="mb-2">Term</h6>
                  <select
                    className="form-control w-100"
                    onChange={(e) => handleInputChange(e, setTerm)}
                  >
                    <option value="select">Select</option>
                    <option value="short">Short</option>
                    <option value="long">long</option>
                  </select>
                </div>
                <div className="form-group">
                  <h6 className="mb-2">Experince needed</h6>
                  <select
                    className="form-control w-100"
                    onChange={(e) => handleInputChange(e, setExperinceNeeded)}
                  >
                    <option value="select">Select</option>
                    <option value="expert">Expert</option>
                    <option value="intermediate">Intermediate</option>
                  </select>
                </div>
                <div className="form-group">
                  <h6 className="mb-2">Length</h6>
                  <select
                    className="form-control w-100"
                    onChange={(e) => handleInputChange(e, setLength)}
                  >
                    <option value="select">Select</option>
                    <option value="1">Less than 1 month</option>
                    <option value="1-3">1-3 months</option>
                    <option value="3-6">3-6 months</option>
                  </select>
                </div>
              </div>
              <div className="col-lg-12 col-md-6 col-12">
                <div className="form-group">
                  <div className="row">
                    <div className="col-lg-3">
                      <h6 className="mb-2">Budget</h6>
                    </div>
                    {/* <div className="col-lg-9">
                      <div className="radio-form">
                        <label htmlFor="hourly" className="mr-3">Hourly</label>
                        <input name="budget" type="radio" id="hourly">
                        <label htmlFor="project-budget" className="mr-3 ml-2">Project Budget</label>
                                      <input name="budget" type="radio" id="project-budget">
                      </div>
                    </div> */}
                    <div className="col-md-12">
                      <input
                        type="number"
                        placeholder="$"
                        onChange={(e) => handleInputChange(e, setBudget)}
                        className="form-control px-3"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12">
                <div className="text-right">
                  <button className="primary-btn primary-bg">
                    Confirm Your Job
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
}
